import { useCallback } from "react";
import { track } from "../../analytics/AnalyticsService.js";
import { AnalyticsTrackingEvent } from "../../analytics/events.js";
import { useConciergeContext } from "../ConciergeContextProvider.js";
const useProductClickTracking = () => {
  const { conversationId } = useConciergeContext();
  const trackProductClick2 = useCallback(
    (params) => {
      if (!conversationId) {
        console.warn("[Concierge] Cannot track product click: no conversationId");
        return;
      }
      const properties = {
        conversationId,
        stacklineSku: params.stacklineSku,
        productTitle: params.productTitle,
        clickSource: params.clickSource,
        productPosition: params.productPosition,
        retailerId: params.retailerId,
        retailPrice: params.retailPrice,
        hasReward: params.hasReward,
        rewardAmount: params.rewardAmount,
        messageIndex: params.messageIndex
      };
      track(
        AnalyticsTrackingEvent.CONCIERGE_PRODUCT_CLICK,
        properties
      ).catch((err) => {
        console.warn("[Concierge] Failed to track product click:", err);
      });
    },
    [conversationId]
  );
  return { trackProductClick: trackProductClick2, conversationId };
};
const trackProductClick = (conversationId, params) => {
  if (!conversationId) {
    console.warn("[Concierge] Cannot track product click: no conversationId");
    return;
  }
  const properties = {
    conversationId,
    stacklineSku: params.stacklineSku,
    productTitle: params.productTitle,
    clickSource: params.clickSource,
    productPosition: params.productPosition,
    retailerId: params.retailerId,
    retailPrice: params.retailPrice,
    hasReward: params.hasReward,
    rewardAmount: params.rewardAmount,
    messageIndex: params.messageIndex
  };
  track(
    AnalyticsTrackingEvent.CONCIERGE_PRODUCT_CLICK,
    properties
  ).catch((err) => {
    console.warn("[Concierge] Failed to track product click:", err);
  });
};
export {
  trackProductClick,
  useProductClickTracking
};
//# sourceMappingURL=useProductClickTracking.js.map
